function ___$insertStyle(css) {
    if (!css || typeof window === 'undefined') {
        return;
    }
    const style = document.createElement('style');
    style.setAttribute('type', 'text/css');
    style.innerHTML = css;
    document.head.appendChild(style);
    return css;
}

var backLeft = {
  "id": "backLeft",
  "symbol": "<symbol id=\"backLeft\" viewBox=\"0 0 11 18\" ><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M8.87893 0L10.9674 2.10181L4.16696 9.01145L11 15.8881L8.92152 18L0 9.02153L8.87893 0Z\" fill=\"#6B7F99\"/></symbol>"
};

export { backLeft };
